import Api from '../../shared/Api';
import { Promise } from 'es6-promise';
import { assign } from '../../shared/Assign';
import IFileUploads from './IFileUploads';

class InvoicesApi {
    static tryInvoiceAgain(invoiceId: number) {
        return new Api().post('/views/invoices/recreate/' + invoiceId, {});
    }

    static newPayment(invoiceId: number): any {
        return new Api().get('/views/invoices/' + invoiceId + '/payments/new');
    }

    static createPayment(
        invoiceId: number,
        paymentDate: Date,
        comment: string,
        amountInclVAT: number,
        amountIncludingVATInInvoiceCurrency: number,
        paymentType: number
    ): any {
        return new Api().post('/views/invoices/' + invoiceId + '/payments', {
            invoiceId: invoiceId,
            date: paymentDate,
            comment: comment,
            amountInclVAT: amountInclVAT,
            amountIncludingVATInInvoiceCurrency: amountIncludingVATInInvoiceCurrency
                ? amountIncludingVATInInvoiceCurrency
                : null,
            type: paymentType
        });
    }

    static getPayments(invoiceId: number): any {
        return new Api().get('/views/invoices/' + invoiceId + '/payments');
    }

    static getInvoicesFilter(): any {
        return new Api().get('/views/invoices/filter');
    }

    static downloadInvoice(id: number): any {
        return new Api().downloadFile('/views/invoices/' + id + '/download');
    }

    static getInvoice(id: number): any {
        return new Api().get('/views/invoices/' + id);
    }

    static getInvoices(filter): any {
        let f = assign({}, filter);
        if (filter.invoiceFromDate) {
            f.fromYear = filter.invoiceFromDate.getYear() + 1900;
            f.fromMonth = filter.invoiceFromDate.getMonth() + 1;
            f.fromDay = filter.invoiceFromDate.getDate();
            delete f.invoiceFromDate;
        }
        if (filter.invoiceToDate) {
            f.toYear = filter.invoiceToDate.getYear() + 1900;
            f.toMonth = filter.invoiceToDate.getMonth() + 1;
            f.toDay = filter.invoiceToDate.getDate();
            delete f.invoiceToDate;
        }
        return new Api().get(`/views/invoices`, f);
    }

    static importPayments(legalEntityId: number, fileuploads: IFileUploads): any {
        return new Api().postFiles(
            `/views/invoices/bgifile?legalEntityId=${legalEntityId}`,
            fileuploads.files
        );
    }

    static newImportPayments(): any {
        return new Api().get(`/views/invoices/bgifile/new`);
    }

    static newCreditInvoice(
        invoiceId: number,
        invoiceDate: any,
        message: string,
        rows: any[]
    ): any {
        return new Api().post(`/views/invoices/${invoiceId}/credit/new`, {
            invoiceDate: invoiceDate,
            message: message,
            rows: rows.map((row: any) => {
                if (row.amount) {
                    row.amount = (row.amount + '').replace(',', '.');
                }

                return row;
            })
        });
    }

    static createCreditInvoice(
        invoiceId: number,
        invoiceDate: any,
        message: string,
        rows: any[]
    ): any {
        return new Api().post(`/views/invoices/${invoiceId}/credit`, {
            invoiceDate: invoiceDate,
            message: message,
            rows: rows.map((row: any) => {
                if (row.amount) {
                    row.amount = (row.amount + '').replace(',', '.');
                }

                return row;
            })
        });
    }
}

export default InvoicesApi;
